module.exports = __webpack_public_path__ + "assets/dc64e41945bbdcf26f1245bd6ff9f458.png";